export enum InterpretationPretestLevel {
  low = '_low',
  middle = '_middle',
  high = '_high',
}

enum SummaryPretestInterval {
  firstIntervalEnd = 35,
  secondIntervalEnd = 46,
}

export const getInterval = (pretestResult: number) => {
  if (pretestResult <= SummaryPretestInterval.firstIntervalEnd)
    return InterpretationPretestLevel.low;
  else if (pretestResult > SummaryPretestInterval.secondIntervalEnd)
    return InterpretationPretestLevel.high;
  return InterpretationPretestLevel.middle;
};
